import PriceRuleAdjustmentOptions from './PriceRuleAdjustmentOptions';
export default PriceRuleAdjustmentOptions;
